import React from 'react';
import Logo from '~/components/Logo';
import Container from '~/components/ui/Container';
import PoweredByVitecLogo from '~/components/Tools/PoweredByVitecLogo';
import PoweredByMoneyViewLogo from '~/components/Tools/PoweredByMoneyViewLogo';

type poweredBy = 'vitec' | 'moneyview';

type ToolLayoutProps = {
  title?: string;
  children: React.ReactNode;
  poweredBy: poweredBy[];
};

const ToolLayout: React.FC<ToolLayoutProps> = ({ title, children, poweredBy }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="relative z-50 flex-none py-2 bg-white shadow-tools-header">
        <Container state="toolLayout">
          <div className="flex items-center justify-between">
            {title && (
              <h1 className="text-blue-600 text-lg md:text-2xl xl:text-3xl font-display font-bold text-balance">{title}</h1>
            )}
            <Logo link="/" />
          </div>
        </Container>
      </header>
      <div className="flex-grow relative">
        <main className="relative z-10">
          <Container className="py-8" state="toolLayout">
            {children}
          </Container>
        </main>
      </div>
      <footer className="relative z-50 flex-none py-2">
        <Container className="flex items-center justify-center md:justify-end" state="toolLayout">
          {poweredBy?.length && (
            <div className="flex items-center gap-4 text-stone-500 text-sm md:text-base">
              <span role="presentation">Powered by</span>
              {poweredBy.includes('vitec') && (
                <PoweredByVitecLogo />
              )}
              {poweredBy.includes('vitec') && poweredBy.includes('moneyview') && (
                <span aria-hidden="true">&amp;</span>
              )}
              {poweredBy.includes('moneyview') && (
                <PoweredByMoneyViewLogo />
              )}
            </div>
          )}
        </Container>
      </footer>
    </div>
  );
};

export default ToolLayout;